/**
 * Extract fields from provided object given list of fields
 * @param {object} objectToExtract Object to extract field data from
 * @param {object} interfaceObject Object contains keys to extract
 * @param {object} mergeObject Object that will be merged into
 * (and overwrite existing data) to result
 * @returns new object that contains the fields extracted from given object
 */
export const fieldsExtractor = (
  objectToExtract,
  interfaceObject,
  mergeObject
) => {
  const result = {};

  Object.keys(interfaceObject)
    .filter((key) => objectToExtract[key] !== undefined)
    .forEach((key) => {
      result[key] = objectToExtract[key];
    });

  if (mergeObject) {
    Object.assign(result, mergeObject);
  }

  return result;
};
